export default __webpack_public_path__ + "static/media/Bebas Neue Pro Book.5199b546.otf";